import SearchItems from './searchItems';
import SearchSubjects from './searchSubjects';

/**
 * Converts an array of results to a sliced array with "+X more"
 * @param {Array} results - Array of results
 * @param {String} [href] - Optional href to make this a link to a page
 * @param {Number} [length=5] - Number of results to show
 */
function resultsWithMore(results, href, length = 5) {
  if(results.length <= length) return results;
  return results.slice(0, length).concat([
    { type: 'more', text: `+${results.length - length} more`, href }
  ]);
}

function itemsSearchUrl(query) {
  return `/classes/search?q=${encodeURIComponent(query)}`;
}

function organizeResults(query, subjects, items) {
  const subjectsHeader = subjects.length ? { type: 'header', text: 'i18n.results_in_tutoring' } : [];
  const itemsHeader = items.length ? { type: 'header', text: 'i18n.results_in_classes' } : [];

  if(!subjects.length && !items.length) {
    return [];
  }

  return [].concat.apply([], [
    subjectsHeader,
    resultsWithMore(subjects),
    itemsHeader,
    resultsWithMore(items, itemsSearchUrl(query))
  ]);
}

/**
 * A class that queries against both Subjects and Items API and aggregates the results.
 */
export default class SearchMulti {
  constructor({ itemsEngine = 'items-st' } = {}) {
    this.searchItems = new SearchItems({ engine: itemsEngine });
    this.searchSubjects = new SearchSubjects;
  }

  /**
   * Performs a fetch against the VTWA Subjects API for the given query.
   * @param {String} query - The string to query
   * @returns {Promise} - Promise containing the results as { type, text, href }
   */
  async search(query) {
    this.searchSubjects.resetAbortController();

    return Promise.all([
      this.searchSubjects.search(query),
      this.searchItems.search(query)
    ]).then((resultsArray) => (
      organizeResults(query, ...resultsArray)
    ));
  }
}
